import { Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useProveedoresColumns from "./useProveedoresColumns";

export default function Lista() {
  const { proveedoresColumns } = useProveedoresColumns();
  const { proveedores } = useSelector((state) => state.proveedoresReducer);

  const [listaFinal, setListaFinal] = useState([]);

  useEffect(() => {
    setListaFinal(proveedores);
  }, [proveedores]);

  const filter = ({ target }) => {
    if (target.value !== "") {
      var newList = proveedores.filter(
        (a) =>
          (a.nombre &&
            a.nombre.toLowerCase().includes(target.value.toLowerCase())) ||
          (a.contactoNombre &&
            a.contactoNombre
              .toLowerCase()
              .includes(target.value.toLowerCase())) ||
          (a.contactoEmail &&
            a.contactoEmail.toLowerCase().includes(target.value.toLowerCase()))
      );
      setListaFinal(newList);
    } else {
      setListaFinal(proveedores);
    }
  };

  return (
    <>
      <Input
        onChange={filter}
        placeholder="buscar"
        style={{ width: 300, marginBottom: 10 }}
      />

      <Table
        rowKey="proveedorID"
        columns={proveedoresColumns}
        dataSource={listaFinal}
      />
    </>
  );
}
